

//현재 자산 가격
export const AdjClose = (asset: any, locale: string | undefined, isActive?: boolean) => {
    if (asset?.CAT === "Index") {
        return asset.ADJ_CLOSE.toLocaleString("en-us", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        })
    }
    if (isActive) {
        if (locale === 'ko') {
            // // 애프터장 가격(미국)
            // if (asset?.ADJ_CUR_KRW_AFTER || String(asset?.ADJ_CUR_KRW_AFTER) === '0') {
            //     return asset.ADJ_CUR_KRW_AFTER.toLocaleString("en-us", {
            //         minimumFractionDigits: 0,
            //         maximumFractionDigits: 0,
            //     }) + `${asset.CAT !== "Index" ? "원" : ""}`
            // }

            if ((asset?.ADJ_CUR_KRW || String(asset?.ADJ_CUR_KRW) === '0')) {
                return asset.ADJ_CUR_KRW.toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                }) + `${asset.CAT !== "Index" ? "원" : ""}`
            }
            else if ((asset?.ADJ_CLOSE_KRW || String(asset?.ADJ_CLOSE_KRW) === '0')) {
                return asset.ADJ_CLOSE_KRW.toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                }) + `${asset.CAT !== "Index" ? "원" : ""}`
            }
            else {
                return "-"
            }
        }
        else {

            if ((asset?.ADJ_CUR_USD || String(asset?.ADJ_CUR_USD) === '0')) {
                return `${asset.CAT !== "Index" ? "$" : ""}` + asset.ADJ_CUR_USD.toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                })
            }
            else if ((asset?.ADJ_CLOSE_USD || String(asset?.ADJ_CLOSE_USD) === '0')) {
                return `${asset.CAT !== "Index" ? "$" : ""}` + asset.ADJ_CLOSE_USD.toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                })
            }
            else {
                return "-"
            }
        }
    }
    else {
        // // 애프터장 가격(미국)
        // if (asset?.ADJ_CLOSE_AFTER || String(asset?.ADJ_CLOSE_AFTER) === '0') {
        //     return asset.ADJ_CLOSE_AFTER.toLocaleString("en-us", {
        //         minimumFractionDigits: 0,
        //         maximumFractionDigits: 0,
        //     }) + `${(asset?.CURR ? asset?.CAT !== 'Index' : "") ? asset.CURR === 'KRW' ? locale === 'ko' ? '원' : "₩" : "$" : ''}`;
        // }
        return asset.ADJ_CLOSE ? `${(asset?.CURR ? asset?.CAT !== 'Index' : "") ? asset.CURR === 'KRW' ? locale === 'ko' ? '' : "" : "$" : ''}` + asset.ADJ_CLOSE.toLocaleString("en-us", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }) + `${(asset?.CURR ? asset?.CAT !== 'Index' : "") ? asset.CURR === 'KRW' ? locale === 'ko' ? '원' : "₩" : "" : ''}` : ""
    }
};

//현재 자산 등락 가격
export const AdjCloseChange = (asset: any, locale: string | undefined, isActive?: boolean) => {
    // const router = useRouter();
    if (asset?.CAT === "Index") {
        return Math.abs(asset?.ADJ_CLOSE_CHANGE).toLocaleString("en-us", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        })
    }

    if (isActive) {


        if (locale === 'ko') {
            // // 애프터장 가격(미국)
            // if (asset?.ADJ_CLOSE_CHANGE_KRW_AFTER || String(asset?.ADJ_CLOSE_CHANGE_KRW_AFTER) === '0') {
            //     return (asset.ADJ_CLOSE_CHANGE_KRW_AFTER || String(asset.ADJ_CLOSE_CHANGE_KRW_AFTER) === '0') ? Math.abs(asset.ADJ_CLOSE_CHANGE_KRW_AFTER).toLocaleString("en-us", {
            //         minimumFractionDigits: 0,
            //         maximumFractionDigits: 0,
            //     }) + "원" : ""
            // }
            return (asset.ADJ_CLOSE_CHANGE_KRW || String(asset.ADJ_CLOSE_CHANGE_KRW) === '0') ? Math.abs(asset.ADJ_CLOSE_CHANGE_KRW).toLocaleString("en-us", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }) + "원" : ""
        }
        else {
            // // 애프터장 가격(미국)
            // if (asset?.ADJ_CLOSE_CHANGE_USD_AFTER || String(asset?.ADJ_CLOSE_CHANGE_USD_AFTER) === '0') {
            //     return (asset.ADJ_CLOSE_CHANGE_USD_AFTER || String(asset.ADJ_CLOSE_CHANGE_USD_AFTER) === '0') ? Math.abs(asset.ADJ_CLOSE_CHANGE_USD_AFTER).toLocaleString("en-us", {
            //         minimumFractionDigits: 0,
            //         maximumFractionDigits: 2,
            //     }) + "원" : ""
            // }
            return (asset.ADJ_CLOSE_CHANGE_USD || String(asset.ADJ_CLOSE_CHANGE_USD) === '0') ? "$" + Math.abs(asset.ADJ_CLOSE_CHANGE_USD).toLocaleString("en-us", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            }) : ""
        }
    }
    else {
        return (asset.ADJ_CLOSE_CHANGE || String(asset.ADJ_CLOSE_CHANGE) === '0') ? `${asset?.CURR ? asset.CURR === 'KRW' ? "" : "$" : ""}` + Math.abs(asset.ADJ_CLOSE_CHANGE).toLocaleString("en-us", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }) + `${asset?.CURR ? asset.CURR === 'KRW' ? locale === 'ko' ? '원' : "₩" : "" : ""}` : ""
    }
};

//현재 자산 등락 퍼센트
export const AdjCloseCHG = (asset: any) => {
    const plus = Number(Number(asset.ADJ_CLOSE_CHG).toFixed(1))

    return (asset.ADJ_CLOSE_CHG || String(asset.ADJ_CLOSE_CHG) === '0') ? (" " +
        `(${plus > 0 ? '+' : plus === 0 ? '' : '-'}`
        +
        Math.abs(asset.ADJ_CLOSE_CHG).toLocaleString("en-us", {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
        }) +
        "%" +
        ")") : ""
};


//현재 자산 등락 가격
export const AdjCloseChangeAfterMaket = (asset: any, locale: string | undefined, isActive?: boolean) => {

    if (isActive) {

        if (locale === 'ko') {
            // 애프터장 가격(미국)
            if (asset?.ADJ_CLOSE_CHANGE_KRW_AFTER || String(asset?.ADJ_CLOSE_CHANGE_KRW_AFTER) === '0') {
                return (asset.ADJ_CLOSE_CHANGE_KRW_AFTER || String(asset.ADJ_CLOSE_CHANGE_KRW_AFTER) === '0') ? Math.abs(asset.ADJ_CLOSE_CHANGE_KRW_AFTER).toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                }) + "원" : ""
            }
            return null;
        }
        else {
            // 애프터장 가격(미국)
            if (asset?.ADJ_CLOSE_CHANGE_USD_AFTER || String(asset?.ADJ_CLOSE_CHANGE_USD_AFTER) === '0') {
                return "$" + Math.abs(asset.ADJ_CLOSE_CHANGE_USD_AFTER).toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                })
            }

        }
    }
    else {
        return (asset.ADJ_CLOSE_CHANGE_AFTER || String(asset.ADJ_CLOSE_CHANGE_AFTER) === '0') ? "$" + Math.abs(asset.ADJ_CLOSE_CHANGE_AFTER).toLocaleString("en-us", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }) : ""
    }
};

//현재 자산 등락 퍼센트
export const AdjCloseCHGAfterMaket = (asset: any) => {
    console.log('Math.abs(asset.ADJ_CLOSE_CHG_AFTER)', Math.abs(asset.ADJ_CLOSE_CHG_AFTER))
    const plus = Number(Number(asset.ADJ_CLOSE_CHG_AFTER).toFixed(1))
    if ((asset.ADJ_CLOSE_CHG_AFTER || String(asset.ADJ_CLOSE_CHG_AFTER) === '0')) {
        return (" " +
            `(${`${plus > 0 ? '+' : plus === 0 ? '' : '-'}`}`
            + Math.abs(asset.ADJ_CLOSE_CHG_AFTER).toLocaleString("en-us", {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
            }) +
            "%" +
            ")")
    }
    return ""
};